import { HubCameraType } from '@robovision/hub'
import { i18n } from '~i18n'
import {
  CameraType,
  EmulatorCameraType,
} from './CameraType'


export interface CameraTypeOption {
  description: string
  extension?: string
  serialFormat?: string
  serialRegex?: RegExp
  title: string
  tool?: string
  value: CameraType
}

export const cameraTypes: CameraTypeOption[] = [
  {
    get description () {
      return i18n.t('cameras.types.baslerDescription')
    },
    extension: '.pfs',
    serialFormat: '12345678',
    serialRegex: /^(\d{8}|0815-000\d)$/,
    get title () {
      return i18n.t('cameras.types.basler')
    },
    tool: 'Basler Pylon viewer',
    value: HubCameraType.BASLER,
  },
  {
    get description () {
      return i18n.t('cameras.types.emulatorDescription')
    },
    get title () {
      return i18n.t('cameras.types.emulator')
    },
    value: EmulatorCameraType.EMULATOR,
  },
  // {
  //   get description () {
  //     return i18n.t('cameras.types.alliedVisionDescription')
  //   },
  //   extension: '.xml',
  //   serialFormat: '12-3456789012',
  //   serialRegex: /^\d{2}-\d{10}$/,
  //   get title () {
  //     return i18n.t('cameras.types.alliedVision')
  //   },
  //   tool: 'Allied Vision Vimba',
  //   value: HubCameraType.ALLIED_VISION,
  // },
]
